export const Config = {
  languages: {
    en: 'English',
    // fr: 'Français',
    it: 'Italiano',
  },
  
  pages: {
    logged_user_home: 'play'
  },

  // Tracks and cars are not configured here: the authoritative sources are server-side
  // (config/tracks.php, config/cars.php) and arrive with the bootstrap (see store.loadBootstrap).
  // Neither are the car colours: which of them a player may pick depends on the account, so they
  // come with its settings (see services/GameOptions).

  standings: {
    // Players per page in the ranking table. A page of the races feed is a server setting
    // (RaceLib::PER_PAGE).
    perPage: 20,
  },

  path: {
  },

  server: {
    routes: {
      api: {
        // Auth. Roles and permissions are not asked for on their own: they travel with the login
        // and with `user` (see services/Auth.js).
        forgot_password: 'password/email',
        login: 'login',
        logout: 'logout',
        register: 'register',
        reset_password: 'password/reset',

        // User related
        dashboard: 'dashboard',
        user: 'user',
        user_settings: 'user/settings',
        // One-off notice for new players: whether it is still to be read, and the acknowledgement
        // (see services/Notice.js)
        user_notice: 'user/notice',
        // Change of the account email (see views/ChangeEmailView.vue)
        user_email: 'user/email',
        // New activation link for the account email (see services/Auth.js)
        email_verification_notification: 'email/verification-notification',

        // Game server proxy
        game_ping: 'game/ping',
        game_launch: 'game/launch',
        game_stress_test: 'game/stress-test',

        // Leaderboard
        leaderboard_summary: 'leaderboard',
        // Times of one track, one page at a time (see views/TrackView.vue)
        leaderboard_track: (trackId, page = 1, perPage = 10) => `leaderboard/${trackId}?page=${page}&per_page=${perPage}`,
        leaderboard_track_car: (trackId, carId) => `leaderboard/${trackId}/${carId}`,

        // Bootstrap: one single call when entering the site (see store.loadBootstrap)
        bootstrap: 'bootstrap',

        // Backend ("gubola"): one standard list endpoint per page (see doc/gubola.md), plus what
        // the editing dialogs need: the two catalogues and the two updates.
        gubola_users: 'gubola/users',
        gubola_permissions: 'gubola/permissions',
        gubola_catalog: 'gubola/catalog',
        gubola_user_roles: (userId) => `gubola/users/${userId}/roles`,
        gubola_role_permissions: (roleId) => `gubola/roles/${roleId}/permissions`,
        // Incident reports pushed by the game server, and the replay the viewer plays
        // (see GPO/doc/replay_collision_detector.md)
        gubola_incidents: 'gubola/incidents',
        gubola_incident: (id) => `gubola/incidents/${id}`,
        gubola_incident_replay: (id) => `gubola/incidents/${id}/replay`,
        gubola_incident_replay_link: (id) => `gubola/incidents/${id}/replay-link`,
        gubola_incident_status: (id) => `gubola/incidents/${id}/status`,
        // Every dismissed report at once; one report is deleted through gubola_incident (both are
        // DELETE, see GubolaController::destroyDismissedIncidents)
        gubola_dismissed_incidents: 'gubola/incidents/dismissed',

        // News (see doc/news.md): the list, and the manual ones created/edited/deleted here
        gubola_news: 'gubola/news',
        gubola_news_item: (id) => `gubola/news/${id}`,

        // Maintenance: the cache keys and emptying them, one key or a whole family (see
        // GubolaController::cache and CacheLib::catalog)
        gubola_cache: 'gubola/maintenance/cache',
        gubola_cache_family: (family) => `gubola/maintenance/cache/${family}`,
        gubola_cache_key: (family, key) => `gubola/maintenance/cache/${family}/${key}`,

        // Standings page: the ranking plus the general standings of the running season (`season`),
        // in one payload. The latest races played have a call of their own, made only when the feed
        // comes into view; the page number walks it for "load more".
        standings: (page, perPage) => `standings?page=${page}&per_page=${perPage}`,
        latest_races: (page = 1) => `races?page=${page}`,

        // Events
        events_summary: 'events',
        // The same list without the standings block of the cards: the light list of the play page
        // (server: `?standings=0`, see EventLib::list)
        events_summary_lite: 'events?standings=0',
        // The rest of the finished archive, one page at a time (see EventListView)
        events_finished: (offset, limit = 20) => `events/finished?offset=${offset}&limit=${limit}`,
        events_detail: (eventId) => `events/${eventId}`,
        events_track: (eventId, trackKey) => `events/${eventId}/tracks/${trackKey}`,
        // Erases the player's own results (a one-attempt event: see EventDetailView)
        events_reset: (eventId) => `events/${eventId}/results`,
        // Erases one stage so it can be raced again, spending one retry of the event (hardcore
        // stage events: see EventDetailView)
        events_retry_stage: (eventId, trackKey) => `events/${eventId}/results/${encodeURIComponent(trackKey)}`,
        // Enable/disable an event that requires an explicit activation, PUT { active }
        // (a stage: see components/EventActivationButton.vue)
        events_activation: (eventId) => `events/${eventId}/activation`,

        // Players
        player_detail: (username) => `players/${encodeURIComponent(username)}`,

        // News (see doc/news.md): the public, paginated list, with the optional category filter. The
        // read acknowledgement needs the account.
        news: (page = 1, perPage = 20, categories = []) => {
          const query = new URLSearchParams({ page: String(page), per_page: String(perPage) })
          categories.forEach(category => query.append('category[]', category))
          return `news?${query.toString()}`
        },
        news_read: (id) => `news/${id}/read`,
        // The automatic news a list just showed, acknowledged in one call (they have no dialog):
        // being shown is being read
        news_read_many: 'news/read',
        // Everything still unread, in one call: the "mark all as read" button of the play page
        news_read_all: 'news/read-all',

        // Push notifications (see src/push/PushSettings.vue). The whole feature stands on its own:
        // when it is switched off on the server these routes answer 404 and the settings page shows
        // nothing at all.
        push_settings: 'push/settings',
        push_subscriptions: 'push/subscriptions',
        push_subscription: (id) => `push/subscriptions/${id}`,
        push_test: 'push/test',
      }
    }
  },
}